module.exports = __webpack_public_path__ + "graphics/checkout-family-icon.ckh.eea4a4d15298f7192042a8350bc54527.svg";